
$(document).ready(function() {
    // 1. activate swatch buttons
    // 2. diable swatches of unavailable variables

    var isAvailable;

    $(".grid_option-swatch").on("click", function() {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
    })
    $(".grid_color-swatch").on("click", function() {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
    })

    // add to cart
    $(document).on("click", '.gird_add-to-cart-btn_wrapper', function (event) {
        let currentElement = this;
        let handle = $(this).attr("button-productHandle");
        let addButton = this;
        let product;
        let variants;
        let variantId;
        jQuery.getJSON('/products/'+ handle +'.js', function(result) {
            product = result;
            variants = product.variants;
        }).done(function() {
            let data = $(currentElement).parent().find(".option-pick.active").attr("data-option");
            for (let i = 0; i < product.variants.length; i++) {
                if (product.variants[i].option1.includes(data)) {
                    variantId = product.variants[i].id
                }
            }
            let formData = {
                'items': [{
                    'id': variantId,
                    'quantity': 1
                }]
            };
        
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                if(response.status == 200) {
                    $('body').trigger('added.ajaxProduct', addButton);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        })
    })
})

$(document).ready(function() {
    $(".size-chart_container").on("click",function() {
        $(this).toggle();
    })
    $(".size_chart").on("click",function() {
        $(".size-chart_container").toggle();
    })
})